import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import AdditionalDriverFlow from './AdditionalDriverFlow';

const AdditionalDriverFlowWrapper = (props) => (
  <Router basename='/'>
    <AdditionalDriverFlow {...props} />
  </Router>
);

export default AdditionalDriverFlowWrapper;
